import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Clients } from './components/Clients';
import { Stats } from './components/Stats';
import { InstagramFeed } from './components/InstagramFeed';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-vm-bg font-inter text-white" data-id="element-0" data-mp="2mmvkesgikcah">
      <Navbar data-id="element-1" data-mp="31bs2licab5ot" />
      <main data-id="element-2" data-mp="31bianp7oiogh">
        <Hero data-id="element-3" data-mp="31c1gw8nyvoeo" />
        <About data-id="element-4" data-mp="31ctaxf1x1e2u" />
        <Stats data-id="element-5" data-mp="2wk0av4he6tx3" />
        <Services data-id="element-6" data-mp="2wjgpfdsj9neb" />
        <InstagramFeed data-id="element-7" data-mp="2wiyvintcfl9k" />
        <Clients data-id="element-8" data-mp="2wip5j08ate3v" />
        <Contact data-id="element-9" data-mp="2wi5nzkmk8rqd" />
      </main>
      <Footer data-id="element-10" data-mp="28tw4wqgqei2x" />
      <WhatsAppButton data-id="element-11" data-mp="28te0v7ntuzkg" />
    </div>;
}